export const ratingDictionary = {
  coverage: 'Qamrov',
  branch: 'Fillial',
  course: 'Kurs',
  level: 'Bosqich',
  myDirection: "Yo'nalishim",
  myCourse: 'Kurslar',
  myGroup: 'Guruhim',
  image: 'Rasm',
  fullName: 'Ism-familiya',
  group: 'Guruh',
  xp: 'XP',
  silver: 'Kumush',
  programming: 'Dasturlash',
  design: 'Dizayn',
  marketing: 'Marketing',
  title: 'Nomi',
  clearFilter: 'Tozalash',
  started: 'Boshlanish sanasi',
  endedDate: 'Tugash sanasi',
  intervalDate: 'Vaqt oralig`i',
  method: 'Metod',
  groupIdNotFound: 'Guruh nomi topilmadi',
  status: 'Status',
  byGroup: 'Guruhim bo‘yicha',
  byOffice: 'Filial bo‘yicha',
  byAllOffice: 'Barcha filiallar bo‘yicha',
  weekly: 'Haftalik',
  monthly: 'Oylik',
  month3: '3 oy',
  leaders: 'yetakchilar',
}
